import { render } from "./AnswerUpdateModal.vue?vue&type=template&id=707f373d&scoped=true&ts=true"
import script from "./AnswerUpdateModal.vue?vue&type=script&lang=ts"
export * from "./AnswerUpdateModal.vue?vue&type=script&lang=ts"

import "./AnswerUpdateModal.vue?vue&type=style&index=0&id=707f373d&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707f373d"]])

export default __exports__